export default {
  account: (state) => state.account,
  currentUser: (state) => state.currentUser,
  rules: (state) => state.rules
}
